var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ActivityIndicator } from '@atomic/atm.activity-indicator';
import { FormFieldContext } from '@atomic/obj.form';
import { TextFieldDismissButtonStyled, TextFieldIconStyled, TextFieldIconWrapperStyled, TextFieldLoadingStyled, TextFieldMaskedStyled, TextFieldStyled, TextFieldWrapperStyled, } from './text-field.component.style';
var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChangeText = function (eventOrText) {
            var value;
            if (typeof eventOrText === 'string') {
                value = eventOrText;
            }
            else {
                value = eventOrText.currentTarget.value;
            }
            if (_this.state && value === _this.state.value) {
                return;
            }
            if (_this.props.onValueChange) {
                _this.props.onValueChange(value);
            }
            if (_this.isControlled()) {
                return;
            }
            if (_this.formFieldConsumer) {
                _this.formFieldConsumer.onValueChange(value, null);
            }
            else {
                _this.setState({ value: value });
            }
        };
        _this.handleInput = function (event) {
            var nextValue = event.currentTarget.value;
            var currentValue = _this.getCurrentValue();
            // HACK: "not fired by keyboard" means that who is calling onInput
            // is not the user by typing letters on the keyboard.
            // For instance, it can be fired by pasting some value or
            // by using form auto-complete.
            // Why is this necessary? auto-complete doesn't fire onChange event
            // but it fires onInput.
            // If you don't handle onInput, some bugs may appear if you use
            // auto-complete on Chrome iOS
            var notFiredByKeyboardTyping = (nextValue.length ? nextValue.length : 0) - (currentValue ? currentValue.length : 0) > 1;
            if (notFiredByKeyboardTyping) {
                event.preventDefault();
                _this.handleChangeText(nextValue);
            }
        };
        _this.handleFocus = function (event) {
            var _a, _b, _c;
            (_a = _this.formFieldConsumer) === null || _a === void 0 ? void 0 : _a.onFocusChange(true);
            (_c = (_b = _this.props).onFocus) === null || _c === void 0 ? void 0 : _c.call(_b, event);
        };
        _this.handleBlur = function (event) {
            var _a, _b, _c;
            (_a = _this.formFieldConsumer) === null || _a === void 0 ? void 0 : _a.onFocusChange(false);
            (_c = (_b = _this.props).onBlur) === null || _c === void 0 ? void 0 : _c.call(_b, event);
        };
        _this.handleDismiss = function () {
            var _a, _b;
            _this.handleChangeText('');
            (_b = (_a = _this.props).onDismiss) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        _this.isControlled = function () {
            return _this.props.value !== undefined;
        };
        _this.getCurrentValue = function () {
            var _a;
            if (_this.isControlled()) {
                return _this.props.value;
            }
            return ((_a = _this.formFieldConsumer) === null || _a === void 0 ? void 0 : _a.value) ? _this.formFieldConsumer.value : _this.state.value;
        };
        _this.state = {
            value: props.initialValue || props.value,
        };
        return _this;
    }
    TextField.prototype.render = function () {
        var _this = this;
        var _a = this.props, autoComplete = _a.autoComplete, variant = _a.variant, icon = _a.icon, options = _a.options, dismissable = _a.dismissable, loading = _a.loading, disabled = _a.disabled, placeholder = _a.placeholder, other = __rest(_a, ["autoComplete", "variant", "icon", "options", "dismissable", "loading", "disabled", "placeholder"]);
        return (React.createElement(FormFieldContext.Consumer, null, function (formFieldConsumer) {
            _this.formFieldConsumer = formFieldConsumer;
            var val = _this.getCurrentValue();
            var sharedProps = __assign({ value: val !== null && val !== void 0 ? val : '', icon: icon,
                autoComplete: autoComplete,
                loading: loading, disabled: disabled || loading, placeholder: placeholder, onInput: _this.handleInput, onBlur: _this.handleBlur, onFocus: _this.handleFocus }, other);
            return (React.createElement(TextFieldWrapperStyled, null,
                icon && (React.createElement(TextFieldIconWrapperStyled, null,
                    React.createElement(TextFieldIconStyled, null))),
                variant === 'normal' ? (React.createElement(TextFieldStyled, __assign({ onChange: _this.handleChangeText }, sharedProps))) : (React.createElement(TextFieldMaskedStyled, __assign({ kind: variant, options: options, onChangeText: _this.handleChangeText }, sharedProps))),
                loading && (React.createElement(TextFieldLoadingStyled, null,
                    React.createElement(ActivityIndicator, { type: "spinner" }))),
                !(_this.props.disabled || _this.props.loading) && _this.props.addon,
                dismissable && (val === null || val === void 0 ? void 0 : val.length) > 0 && React.createElement(TextFieldDismissButtonStyled, { onClick: _this.handleDismiss })));
        }));
    };
    TextField.prototype.componentDidMount = function () {
        if (this.isControlled() && this.props.initialValue !== undefined) {
            throw new Error('Use either the initialValue prop, or the value prop, but not both');
        }
        if (this.formFieldConsumer) {
            if (this.isControlled() || this.props.initialValue !== undefined) {
                if (this.formFieldConsumer.value) {
                    throw new Error('Please, use either value props in <TextField> or <Form.Field> component.');
                }
                this.formFieldConsumer.onValueChange(this.state.value, null);
            }
        }
    };
    TextField.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b, _c;
        if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
            (_b = (_a = this.props).onValueChange) === null || _b === void 0 ? void 0 : _b.call(_a, this.props.value);
            (_c = this.formFieldConsumer) === null || _c === void 0 ? void 0 : _c.onValueChange(this.props.value, null);
            this.setState({ value: this.props.value });
        }
    };
    TextField.defaultProps = {
        variant: 'normal',
    };
    return TextField;
}(React.Component));
export { TextField };
